export default "__VITE_ASSET__47317f35__"